/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'
// import { Box } from '@chakra-ui/react'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const AGSUSIconOutline = createIcon({
  displayName: 'AGSUSIconOutline',
  viewBox: '0 0 24 24',
  path: <></>,
})

const AGSUSIconFilled = createIcon({
  displayName: 'AGSUSIconFilled',
  viewBox: '0 0 759 760.36',
  path: (
    <>
      <path
        d="M513.73,472V285.65L456.6,227.16h-136V120.72S334.17,74.8,365.45,74.8H476.22l-.58,127.87L535.5,268H689.22S779,288.37,779,357.75V535.88L570.87,536s5.44-27.21,24.48-27.21H754.51V356.39S726,295.17,689.22,295.17H543.66V458.42S534.14,474.74,513.73,472Z"
        transform="translate(-20 -21.78)"
        fill="currentColor"
      />
      <path
        d="M327.4,516.87H513.77l58.49-57.13v-136H678.7s45.92,13.53,45.92,44.82V479.36l-127.87-.58-65.3,59.86V692.36s-20.4,89.78-89.78,89.78H263.54L263.46,574s27.21,5.44,27.21,24.48V757.66H443s61.22-28.57,61.22-65.3V546.8H341S324.68,537.28,327.4,516.87Z"
        transform="translate(-20 -21.78)"
        fill="currentColor"
      />
      <path
        d="M285.27,330.54V516.91l57.13,58.5h136V681.84s-13.53,45.93-44.81,45.93H322.78l.58-127.88L263.5,534.6H109.78S20,514.19,20,444.81V266.68l208.13-.07s-5.44,27.2-24.48,27.2H44.49V446.17s28.56,61.22,65.29,61.22H255.34V344.15S264.86,327.82,285.27,330.54Z"
        transform="translate(-20 -21.78)"
        fill="currentColor"
      />
      <path
        d="M471.6,287.05H285.23l-58.49,57.13v136H120.3s-45.92-13.52-45.92-44.81V324.56l127.87.58,65.3-59.86V111.56S288,21.78,357.33,21.78H535.46l.08,208.13s-27.21-5.44-27.21-24.48V46.27H356s-61.22,28.56-61.22,65.29V257.12H458S474.32,266.64,471.6,287.05Z"
        transform="translate(-20 -21.78)"
        fill="currentColor"
      />
    </>
  ),
})

const AGSUSIconTwoTone = createIcon({
  displayName: 'AGSUSIconTwoTone',
  viewBox: '0 0 759 760.36',
  path: (
    <>
      <path
        d="M513.73,472V285.65L456.6,227.16h-136V120.72S334.17,74.8,365.45,74.8H476.22l-.58,127.87L535.5,268H689.22S779,288.37,779,357.75V535.88L570.87,536s5.44-27.21,24.48-27.21H754.51V356.39S726,295.17,689.22,295.17H543.66V458.42S534.14,474.74,513.73,472Z"
        transform="translate(-20 -21.78)"
        fill="#0d0"
      />
      <path
        d="M327.4,516.87H513.77l58.49-57.13v-136H678.7s45.92,13.53,45.92,44.82V479.36l-127.87-.58-65.3,59.86V692.36s-20.4,89.78-89.78,89.78H263.54L263.46,574s27.21,5.44,27.21,24.48V757.66H443s61.22-28.57,61.22-65.3V546.8H341S324.68,537.28,327.4,516.87Z"
        transform="translate(-20 -21.78)"
        fill="#1331ff"
      />
      <path
        d="M285.27,330.54V516.91l57.13,58.5h136V681.84s-13.53,45.93-44.81,45.93H322.78l.58-127.88L263.5,534.6H109.78S20,514.19,20,444.81V266.68l208.13-.07s-5.44,27.2-24.48,27.2H44.49V446.17s28.56,61.22,65.29,61.22H255.34V344.15S264.86,327.82,285.27,330.54Z"
        transform="translate(-20 -21.78)"
        fill="red"
      />
      <path
        d="M471.6,287.05H285.23l-58.49,57.13v136H120.3s-45.92-13.52-45.92-44.81V324.56l127.87.58,65.3-59.86V111.56S288,21.78,357.33,21.78H535.46l.08,208.13s-27.21-5.44-27.21-24.48V46.27H356s-61.22,28.56-61.22,65.29V257.12H458S474.32,266.64,471.6,287.05Z"
        transform="translate(-20 -21.78)"
        fill="#fd0"
      />
    </>
  ),
})

// const AGSUSIconTwoTone = createIcon({
//   displayName: 'AGSUSIconTwoTone',
//   viewBox: '0 0 800 800',
//   path: (
//     <>
//       <Box
//         as="path"
//         d="M513.73,472V285.65L456.6,227.16h-136V120.72S334.17,74.8,365.45,74.8H476.22l-.58,127.87L535.5,268H689.22S779,288.37,779,357.75V535.88L570.87,536s5.44-27.21,24.48-27.21H754.51V356.39S726,295.17,689.22,295.17H543.66V458.42S534.14,474.74,513.73,472Z"
//         transform="translate(-20 -21.78)"
//         fill="twoToneStrokeColor"
//       />
//       <Box
//         as="path"
//         d="M327.4,516.87H513.77l58.49-57.13v-136H678.7s45.92,13.53,45.92,44.82V479.36l-127.87-.58-65.3,59.86V692.36s-20.4,89.78-89.78,89.78H263.54L263.46,574s27.21,5.44,27.21,24.48V757.66H443s61.22-28.57,61.22-65.3V546.8H341S324.68,537.28,327.4,516.87Z"
//         transform="translate(-20 -21.78)"
//         fill="twoToneFillColor"
//       />
//       <Box
//         as="path"
//         d="M285.27,330.54V516.91l57.13,58.5h136V681.84s-13.53,45.93-44.81,45.93H322.78l.58-127.88L263.5,534.6H109.78S20,514.19,20,444.81V266.68l208.13-.07s-5.44,27.2-24.48,27.2H44.49V446.17s28.56,61.22,65.29,61.22H255.34V344.15S264.86,327.82,285.27,330.54Z"
//         transform="translate(-20 -21.78)"
//         fill="twoToneStrokeColor"
//       />
//       <Box
//         as="path"
//         d="M471.6,287.05H285.23l-58.49,57.13v136H120.3s-45.92-13.52-45.92-44.81V324.56l127.87.58,65.3-59.86V111.56S288,21.78,357.33,21.78H535.46l.08,208.13s-27.21-5.44-27.21-24.48V46.27H356s-61.22,28.56-61.22,65.29V257.12H458S474.32,266.64,471.6,287.05Z"
//         transform="translate(-20 -21.78)"
//         fill="twoToneFillColor"
//       />
//     </>
//   ),
// })

const AGSUS: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'twoTone':
      return <CustomIcon as={AGSUSIconTwoTone} {...props} />
    case 'filled':
      return <CustomIcon as={AGSUSIconFilled} {...props} />
    default:
      return <CustomIcon as={AGSUSIconOutline} {...props} />
  }
}

export default memo(AGSUS)
